import React, { useState } from "react";
import { GET_JOB_POST_BY_ID } from "@/GraphQL/Queries";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router";
import Pagination from "@mui/material/Pagination";
import { Button, Card, CardBody, Col, Modal, Row, Table } from "reactstrap";
import imageUrl from "@/utils/api/imageUrl";
import BreadCrumb from "@/shared/components/BreadCrumb/BreadCrumb";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import moment from "moment";
import ApplicantDetailsModal from "./ApplicantModal";

const ITEMS_PER_PAGE = 10;

export default function JobDetails() {
  const history = useHistory();
  const id = history?.location?.state?.updateData?.id;
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [showModal, setShowModal] = useState(false);
  console.log("🚀 ~ JobDetails ~ showModal:", showModal);

  const handleRowClick = (applicant) => {
    setSelectedApplicant(applicant);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedApplicant(null);
  };
  //

  const { data, loading, error } = useQuery(GET_JOB_POST_BY_ID, {
    variables: { id: Number(id) },
    skip: !id,
    fetchPolicy: "network-only",
  });

  const job = data?.getJobPostById?.data;
  const applicants = job?.applicants || [];

  const totalPages = Math.ceil(applicants.length / ITEMS_PER_PAGE);

  const handleChange = (_event, value) => {
    setCurrentPage(value);
  };

  const paginatedApplicants = applicants.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "JobPost List",
      link: "/job_post/list",
    },
    {
      name: "Job Post Details",
    },
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <SubmitLoading color="black" />
      </div>
    );
  }
  if (error) return <p>Error: {error.message}</p>;
  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <BreadCrumb breadCrumbData={breadCrumbData} />
          </Col>
        </Row>
        <div className="container mt-4 pb-5">
          <h2 className="mb-3">{job?.job_title}</h2>
          <p>
            <strong>Salary:</strong> {job?.salary}
          </p>
          <p>
            <strong>Work Place:</strong> {job?.work_place}
          </p>
          <p>
            <p>
              <strong>Deadline:</strong>{" "}
              {job?.dead_line
                ? moment(Number(job.dead_line)).format("D MMMM, YYYY")
                : "-"}
            </p>
          </p>
          <p>
            <strong>Status:</strong> {job?.is_active ? "Active" : "Inactive"}
          </p>
          <div
            className="border p-3 rounded mb-4"
            dangerouslySetInnerHTML={{ __html: job?.description }}
          />

          <h4>Applicants ({applicants.length})</h4>

          {paginatedApplicants.length === 0 ? (
            <p>No applicants yet.</p>
          ) : (
            <>
              <Table striped bordered hover responsive className="mt-3">
                <thead>
                  <tr>
                    <th>Sl No.</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Present Address</th>
                    <th>University</th>
                    <th>Department</th>
                    <th>CGPA</th>
                    <th>CV</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedApplicants.map((app, index) => (
                    <tr key={app.id}>
                      <td onClick={() => handleRowClick(app)}>
                        {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                      </td>
                      <td>
                        <div className="employee-list__img-wrap">
                          <a
                            href={`${imageUrl}/profile/${
                              app.profile_image ||
                              "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                            }`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${imageUrl}/profile/${
                                app.profile_image ||
                                "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                              }`}
                              alt="Profile"
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src =
                                  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";
                              }}
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          </a>
                        </div>
                      </td>
                      <td>{app?.name}</td>
                      <td>{app?.email}</td>
                      <td>{app?.mobile}</td>
                      <td>{app?.address}</td>
                      <td>{app?.university}</td>
                      <td>{app?.department}</td>
                      <td>{app?.cgpa ? app?.cgpa : "N/A"}</td>
                      <td>
                        {app?.cv ? (
                          <a
                            href={`${imageUrl}/cv/${app?.cv}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View CV
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <div className="d-flex justify-content-center mt-3">
                <Pagination
                  className="mt-2"
                  count={totalPages}
                  page={currentPage}
                  onChange={handleChange}
                  // color="primary"
                />
              </div>
              <ApplicantDetailsModal
                isOpen={showModal}
                toggle={() => setShowModal(false)}
                applicant={selectedApplicant}
              />
            </>
          )}
        </div>
      </CardBody>
    </Card>
  );
}
